

import React, { useEffect, useState, useMemo } from "react";

import queryString from 'query-string';

import { Link } from "react-router-dom";

import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

const MAX_PAGES = 10;

export default function Pagination({ total, per = 25, className, location, ...rest }) {
  const totalOfPages = Math.ceil(total / per);

  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);

  const current = useMemo(() => {
    const queryParams = queryString.parse(window.location.hash.split('?')[1]);
    return parseInt(queryParams.page, 10) || 1;
  }, [window.location.hash])

  const pages = useMemo(() => {
    let pageStart = 1;
    const length = totalOfPages >= MAX_PAGES ? MAX_PAGES : totalOfPages;

    if (current <= length - Math.floor(length / 2))  {
      pageStart = 1
    } else if (current + Math.floor(length / 2) > totalOfPages ) {
      const something = totalOfPages - current + 1
      pageStart = current - (length - (something))
    } else  {
      pageStart = current - (length - Math.ceil(length / 2))
    }

    const queryParams = queryString.parse(window.location.hash.split('?')[1]);
    delete queryParams.page;
    const queryParamsString = Object.keys(queryParams).length ? `&${queryString.stringify(queryParams)}` : '';

    return Array.from({ length }).map((value, index) => ({
      url: `${location.pathname}?page=${index + pageStart}${queryParamsString}`,
      number: index + pageStart
    }))
  }, [current, totalOfPages, window.location])

  useEffect(() => {
    setPrevious(current > 1 ? current - 1 : null);
    setNext(current < totalOfPages ? current + 1 : null);
  }, [current, totalOfPages]);

  return !!total && (
    <ul className={`pagination pagination-split ${className}`}>
      <li className="page-item">
        <Link to={`${location.pathname}?page=${previous}`} className={`page-link ${previous === null ? 'disabled' : ''}`}>
          <FaChevronLeft />
        </Link>
      </li>
      {pages.map(page => (
        <li className={`page-item ${current === page.number ? 'active' : ''}`} key={`pagination-page-${page.number}`}>
          <Link to={page.url} className="page-link">{page.number}</Link>
        </li>
      ))}
      <li className="page-item ">
        <Link to={`${location.pathname}?page=${next}`} className={`page-link ${next === null ? 'disabled' : ''}`}>
          <FaChevronRight />
        </Link>
      </li>
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js